// @flow
import React, { useContext } from 'react';

import ResponsiveContext from 'Components/utils/responsive/responsiveContext';

import { SearchCompareLarge } from './large/SearchCompareLarge.jsx';
import { SearchCompareNarrow } from './narrow/SearchCompareNarrow.jsx';

type Props = {
  buttonLabel: string,
  cancelLabel: string,
  children?: Node,
  className?: string,
  collapseLabel?: string,
  comparisonToggle: () => void,
  comparisonClick: () => void,
  comparisonUrl: string,
  dropzoneLabel?: string,
  expandLabel?: string,
  isComparisonActive?: boolean,
  isComparisonSubmitable?: boolean,
  mandatoryMessage?: string,
  selectedItems?: Array<*>,
  selectedItemsCount?: number,
  selectedItemsMax: number,
  toggleProductSelectedForComparison: ?(string) => *,
};

export function SearchCompare(props: Props) {
  const { isDesktop } = useContext(ResponsiveContext);
  return isDesktop ? <SearchCompareLarge {...props} /> : <SearchCompareNarrow {...props} />;
}
